/**
 * Transcription store
 */
import { create } from 'zustand';
export const useTranscriptionStore = create((set, get) => ({
    transcripts: {},
    statuses: {},
    isLoading: {},
    errors: {},
    setTranscript: (meetingId, transcript) => {
        set((state) => ({
            transcripts: {
                ...state.transcripts,
                [meetingId]: transcript,
            },
        }));
    },
    setStatus: (meetingId, status) => {
        set((state) => ({
            statuses: {
                ...state.statuses,
                [meetingId]: status,
            },
        }));
    },
    setLoading: (meetingId, isLoading) => {
        set((state) => ({
            isLoading: {
                ...state.isLoading,
                [meetingId]: isLoading,
            },
        }));
    },
    setError: (meetingId, error) => {
        set((state) => ({
            errors: {
                ...state.errors,
                [meetingId]: error,
            },
        }));
    },
    getTranscript: (meetingId) => {
        return get().transcripts[meetingId] || null;
    },
    getStatus: (meetingId) => {
        return get().statuses[meetingId] || null;
    },
    clear: (meetingId) => {
        if (meetingId) {
            set((state) => {
                const newState = { ...state };
                delete newState.transcripts[meetingId];
                delete newState.statuses[meetingId];
                delete newState.isLoading[meetingId];
                delete newState.errors[meetingId];
                return newState;
            });
        }
        else {
            set({
                transcripts: {},
                statuses: {},
                isLoading: {},
                errors: {},
            });
        }
    },
}));
//# sourceMappingURL=transcription.js.map